export const iosUrl = "https://wwww.baidu.com";
export const androidUrl = "https://wwww.baidu.com";
